// `chat` stays labelled so history from before Hub Announcements went (XN-4389)
// still reads.
const CHANNEL_LABELS = { email: 'Email', chat: 'Message' };

export const channelLabel = (channel) => CHANNEL_LABELS[channel] ?? channel;

export const channelChips = (channels) => (channels || []).map(channelLabel);
